<template>
  <div>
    <div class="sidebar" id="mobile">
      <SidebarHeader />
      <SidebarForm />
      <nav class="sidebar-nav">
        <div slot="header"></div>
        <ul class="nav">
          
          <li v-if="is_admin === true" class="nav-item">
            <a href="#/CompaniesInfo" class="nav-link"><i class="icon-speedometer"></i> Companies Info</a>
          </li>
          <li v-if="is_admin === true" class="nav-item nav-dropdown active" disabled="disabled">
            <div class="nav-link nav-dropdown-toggle" @click="handleClick1">
             <i class="fa fa-users"></i>Manage User
           </div>
           <ul class="nav-dropdown-items dropdown-content">
            <li class="nav-item">
              <a href="#/user_management/user_info" class="nav-link">User Info</a>
            </li>
            <li class="nav-item">
                <a href="#/user_management/user_status" class="nav-link">User Status</a>
            </li>
          </ul>
        </li>
        <li v-if="is_admin === true" class="nav-item">
            <a href="#/PlanConfig" class="nav-link">
              <i class="fa fa-tasks"></i> Plan Configuration
            </a>
        </li>
          <li v-if="dashboard === true" class="nav-item">
            <div>
              <a href="#/dashboard" class="nav-link"><i class="icon-speedometer"></i> Dashboard</a>
            </div>
          </li>
        
           <!-- start companydetails -->

          <li v-if="company_tab === true || is_admin === true" class="nav-item nav-dropdown active" disabled="disabled">
            <div class="nav-link nav-dropdown-toggle" @click="handleClick1">
              <i class="fa fa-building-o"></i> Inventory Info
            </div>
            <ul id="destopview" class="nav-dropdown-items dropdown-content">
                  <li v-if="tax_tab === true || is_admin === true" class="nav-item nav-dropdown" disabled="disabled">
                <div class="nav-link nav-dropdown-toggle" @click="handleClick1"> <i class="fa fa-building-o"></i>
                Company Info
                </div>
                <ul id="destopview" class="nav-dropdown-items dropdown-content">
                   <li v-if="(company_reg === true && super_user == 1) || shop_user == 2">
              <a href="#/companyinfo/Registration" class="nav-link">Company Registration</a>
            </li>
            <li v-if="shop_details === true && super_user == 1">
              <a href="#/companyinfo/Shop" class="nav-link">Shop Details</a>
            </li>
                </ul>
              </li>
             
            </ul>
            <ul id="destopview" class="nav-dropdown-items dropdown-content">
                  <li v-if="tax_tab === true || is_admin === true" class="nav-item nav-dropdown" disabled="disabled">
                <div class="nav-link nav-dropdown-toggle" @click="handleClick1"><i class="fa fa-shield"></i>
                Define Security
                </div>
                <ul id="destopview" class="nav-dropdown-items dropdown-content">
                 <li class="nav-item">
              <div v-if="(users === true && super_user == 1) || shop_user == 2">
                <a href="#/Definesecurity/User" class="nav-link">Add / Update Users</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="super_user == 1">
                <a href="#/Definesecurity/Role" class="nav-link">Add / Update Roles</a>
              </div>
            </li>
                </ul>
              </li>
             
            </ul>
                <ul id="destopview" class="nav-dropdown-items dropdown-content">
                  <li v-if="tax_tab === true || is_admin === true" class="nav-item nav-dropdown" disabled="disabled">
                <div class="nav-link nav-dropdown-toggle" @click="handleClick1"><i class="fa fa-pie-chart"></i>
              Sales
                </div>
                <ul id="destopview" class="nav-dropdown-items dropdown-content">
                <li v-if="sales === true" class="nav-item">
              <a href="#/sales" class="nav-link">Sale Entry</a>
            </li>
            <!---<li class="nav-item" v-if="sale_return === true">
              <div>
                <a href="#/Salesreturn/list" class="nav-link">Sale Return</a>
              </div>
            </li>---->
            <li v-if="customer === true" class="nav-item">
              <a href="#/sales/Customeradd" class="nav-link">Add / Update Customer</a>
            </li>
            <li v-if="sale_invoice === true" class="nav-item">
              <a href="#/sales/saleinvoice/list" class="nav-link">Sale Invoice</a>
            </li>
            <li v-if="sale_receipt === true" class="nav-item">
              <div>
                <a href="#/sales/salereceipt" class="nav-link">Sales Receipt</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="sale_receipt_history === true">
                <a href="#/sales/Salesreceipthistory" class="nav-link">Sales Receipt History</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="salereturn_receipt_history === true">
                <!-- <div v-if="sale_receipt_history === true"> -->
                  <a href="#/sales/SalesReturnreceipthistory" class="nav-link">Sales Return Receipt History</a>
                </div>
              </li>
                </ul>
              </li>
             
            </ul>    <ul id="destopview" class="nav-dropdown-items dropdown-content">
                  <li v-if="tax_tab === true || is_admin === true" class="nav-item nav-dropdown" disabled="disabled">
                <div class="nav-link nav-dropdown-toggle" @click="handleClick1"><i class="fa fa-shopping-cart"></i>
                Purchase 
                </div>
                <ul id="destopview" class="nav-dropdown-items dropdown-content">
             <li v-if="purchase === true" class="nav-item">
                <a href="#/purchase/purchaseentry" class="nav-link">Purchase Entry</a>
              </li>
              <!----<li v-if="purchase_return === true" class="nav-item">
                <a href="#/purchase/Listpurchesreturn" class="nav-link">Purchase Return</a>
              </li>------>
              <li class="nav-item">
                <div v-if="supplier === true">
                  <a href="#/purchase/supplier/add" class="nav-link">Add / Update Supplier</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="purchase_payment === true">
                <a href="#/purchase/addpayment" class="nav-link">Add Payment</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="purchase_payment_history === true">
                <a href="#/purchase/listpayment" class="nav-link">List Payment</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="purchasereturn_pending_list === true">
                <a href="#/purchase/PurchaseReturnpayment" class="nav-link">List Purchase Return Payment</a>
              </div>
            </li>
                </ul>
              </li>
             
            </ul>    
            <ul id="destopview" class="nav-dropdown-items dropdown-content">
                <li  v-if="shop_inventory === true">
             <div>
                 <a href="#/shopinventory" class="nav-link"><i class="icon-social-dropbox"></i> Shop Inventory</a>
              </div>
          
            </li>
             
            </ul>    
            <ul id="destopview" class="nav-dropdown-items dropdown-content">
                 <li v-if="stock_transfer === true" class="nav-item">
          <div>
            <a href="#/stocktransfer" class="nav-link"><i class="icon-speedometer"></i> Stock Transfer</a>
          </div>
        </li>
             
            </ul>    
            <ul id="destopview" class="nav-dropdown-items dropdown-content">
                  <li v-if="tax_tab === true || is_admin === true" class="nav-item nav-dropdown" disabled="disabled">
                <div class="nav-link nav-dropdown-toggle" @click="handleClick1"> <i class="fa fa-cogs"></i> 
               Reports 
                </div>
                <ul id="destopview" class="nav-dropdown-items dropdown-content">
                 <li v-if="sales_tab === true" class="nav-item">
              <a href="#/reports/balance_receipt_list" class="nav-link">Balance Receipt List</a>
            </li>
            <li v-if="purchase_tab === true" class="nav-item">
              <a href="#/reports/pending_payment_list" class="nav-link">Pending Payment List</a>
            </li>
                </ul>
              </li>
             
            </ul>    <ul id="destopview" class="nav-dropdown-items dropdown-content">
                  <li v-if="tax_tab === true || is_admin === true" class="nav-item nav-dropdown" disabled="disabled">
                <div class="nav-link nav-dropdown-toggle" @click="handleClick1"> <i class="fa fa-cogs"></i>
                Setup 
                </div>
                <ul id="destopview" class="nav-dropdown-items dropdown-content">
                 <li class="nav-item">
              <div v-if="category_sub_category === true || is_admin === true">
                <a href="#/setup/addupdatecategory" class="nav-link">Add / Update Category</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="brand === true || is_admin === true">
                <a href="#/setup/addupdatebrand" class="nav-link">Add / Update Brand</a>
              </div>
            </li>
             <li v-if="tax_tab === true || is_admin === true" class="nav-item nav-dropdown" disabled="disabled">
                <div class="nav-link nav-dropdown-toggle" @click="handleClick1">
                  Tax Details
                </div>
                <ul id="destopview" class="nav-dropdown-items dropdown-content">
                  <li v-if="hsn === true || is_admin === true" class="nav-item">
                    <div>
                      <a href="#/setup/taxdetails/hsn" class="nav-link">HSN</a>
                    </div>
                  </li>
                  <li v-if="tax === true || is_admin === true" class="nav-item">
                    <div>
                      <a href="#/setup/taxdetails/hsnrate" class="nav-link">HSN Rate</a>
                    </div>
                  </li>
                </ul>
            </li>
            <li class="nav-item">
              <div v-if="variant === true || is_admin === true">
                <a href="#/setup/addupdatevariant" class="nav-link">Add / Update Variant</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="unit === true || is_admin === true">
                <a href="#/setup/addupdateunit" class="nav-link">Add / Update Unit</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="product === true">
                <a href="#/setup/addupdateproduct" class="nav-link">Add / Update Product</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="product === true">
                <a href="#/setup/barcode" class="nav-link">Print Barcode</a>
              </div>
            </li>
            </ul>
            </li>
        
      </ul>
    </li>
             

          <!-- end setting -->
           <!-- <li class="nav-item">
            <div>
              <a href="#/createcard" class="nav-link"
              ><i class="icon-social-dropbox"></i> Create Card</a
              >
            </div>
        </li> -->
         <!-- <li class="nav-item">
            <div>
              <a href="#/Cardlist" class="nav-link"
              ><i class="icon-social-dropbox"></i> Card List</a
              >
            </div>
        </li> -->
        <!-- <li class="nav-item">
            <div>
              <a href="#/sendsms" class="nav-link"
              ><i class="icon-social-dropbox"></i> Send SMS</a
              >
            </div>
        </li>
        <li class="nav-item">
            <div>
              <a href="#/dailyreport" class="nav-link"
              ><i class="icon-social-dropbox"></i> Report</a
              >
            </div>
        </li> -->
        <li class="nav-item" v-if="customer_tab === true">
          <div>
            <a href="#/customerdashboard" class="nav-link "><i class="icon-speedometer "></i>Dashboard</a>
          </div>
        </li>
          
        <li class="nav-item" v-if="customer_tab === true">
          <div>
            <a href="#/customerdetails" class="nav-link"><i class="icon-speedometer"></i> Profile Detail</a>
          </div>
        </li>
        <li class="nav-item" v-if="customer_tab === true">
          <div>
            <a href="#/customerCompany" class="nav-link"><i class="icon-speedometer"></i>Company Schemes</a>
          </div>
        </li>
        <li class="nav-item" v-if="customer_tab === true">
          <div>
            <a href="#"  @click="mobileSidebarToggle" class="nav-link"><i class="icon-speedometer"></i>Hide Menu</a>
          </div>
        </li>
        <!-- <li class="nav-item">
            <div>
              <a href="#/carddetails" class="nav-link"
              ><i class="icon-social-dropbox"></i>Card Details</a
              >
            </div>
        </li> -->
         <!-- <li class="nav-item">
            <div>
              <a href="#/goldscheme" class="nav-link"
              ><i class="icon-social-dropbox"></i>Gold Schemes</a
              >
            </div>
        </li> -->
        <li v-if="setup_tab === true || is_admin === true" class="nav-item nav-dropdown" disabled="disabled">
            <div class="nav-link nav-dropdown-toggle" @click="handleClick1">
              <i class="fa fa-shopping-cart"></i>Scheme
            </div>
            <ul id="destopview" class="nav-dropdown-items dropdown-content">
             <li class="nav-item">
              <a href="#/sales/Customeradd" class="nav-link">Add / Update Customer</a>
            </li>
            <li class="nav-item">
            <div>
              <a href="#/createcard" class="nav-link">Create Card</a>
            </div>
            </li>
            <li class="nav-item">
            <div>
              <a href="#/Cardlist" class="nav-link">Card List</a>
            </div>
            </li>
            <li class="nav-item">
            <div>
              <a href="#/closelist" class="nav-link">Card Close List</a>
            </div>
            </li>
            <li class="nav-item">
            <div>
              <a href="#/refwalletlist" class="nav-link">Ref. Wallet List</a>
            </div>
            </li>
             <li class="nav-item">
            <div>
              <a href="#/custDueList" class="nav-link">Customer Due List</a>
            </div>
            </li>
            <!-- <li class="nav-item">
            <div>
              <a href="#/sendsms" class="nav-link">Send SMS</a>
            </div>
            </li> -->
            <li class="nav-item">
            <div>
              <a href="#/goldscheme" class="nav-link">Gold Schemes</a>
            </div>
        </li>
              
            </ul>
          </li>
         
        </ul>
        <slot></slot>
      </nav>
      <SidebarFooter />
      <SidebarMinimizer />
    </div>

    <!-- DESKTOP SIDEBAR -->
    <div class="sidebar" id="destop">
      <SidebarHeader />
      <SidebarForm />

      <nav class="sidebar-nav" id="">
        <div slot="header"></div>
        <ul class="nav">
          <li class="nav-item">
            <div v-if="is_admin === true">
              <a href="#/CompaniesInfo" class="nav-link"
              ><i class="icon-speedometer"></i> Companies Info</a
              >
            </div>
          </li>
          <li v-if="is_admin === true" class="test2">
            <div class="dropbtn nav-link">
             <i class="fa fa-users"></i>Manage User<i
             class="fa fa-angle-double-right"
             style="float: right; color: #fff;"
             ></i>
           </div>
           <ul class="test top-level-menu">
            <li class="nav-item">
              <div v-if="is_admin === true">
                <a href="#/user_management/user_info" class="">User Info</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="brand === true || is_admin === true">
                <a href="#/user_management/user_status" class="">User Status</a>
              </div>
            </li>
          </ul>
        </li>
        <li class="nav-item">
          <div v-if="is_admin === true">
            <a href="#/PlanConfig" class="nav-link">
              <i class="fa fa-tasks"></i> Plan Configuration
            </a>
          </div>
        </li>
        <li v-if="dashboard === true" class="nav-item">
          <div>
            <a href="#/dashboard" class="nav-link"
            ><i class="icon-speedometer"></i> Dashboard</a
            >
          </div>
        </li>
      <!----------  <li v-if="company_tab === true" class="test2">
          <div class="dropbtn nav-link">
            <i class="fa fa-building-o"></i>Company Info<i
            class="fa fa-angle-double-right"
            style="float: right; color: #fff;"
            ></i>
          </div>
          <ul class="test top-level-menu">
             <li v-if="(company_reg === true && super_user == 1) || shop_user == 2">
              <a href="#/companyinfo/Registration">Company Registration</a>
            </li>
            <li v-if="shop_details === true && super_user == 1">
              <a href="#/companyinfo/Shop">Shop Details</a>
            </li>
         
          </ul>
        </li>---------->
            <li class="test2"  v-if="setup_tab === true || is_admin === true" >
          <div class=" nav-link"><i class="icon-social-dropbox"></i> Inventory Info<i class="fa fa-angle-double-right" style="float: right; color: #fff;"></i>
          </div>
          <ul class="test top-level-menu">
          <li v-if="company_tab === true || is_admin === true" class="">
              <div class="d nav-link"><i class="fa fa-building-o"></i>Company Info<i class="fa fa-angle-double-right" style="float: right; color: #fff;"></i>
          </div>
              <ul class="second-level-menu">
                   <li v-if="(company_reg === true && super_user == 1) || shop_user == 2">
              <a href="#/companyinfo/Registration">Company Registration</a>
            </li>
            <li v-if="shop_details === true && super_user == 1">
              <a href="#/companyinfo/Shop">Shop Details</a>
            </li>
              </ul>
            </li>
            <li v-if="security_tab === true || is_admin === true" class="">
              <div class=" nav-link"><i class="fa fa-shield"></i>Define Security<i class="fa fa-angle-double-right"style="float: right; color: #fff;"></i>
          </div>
              <ul class="second-level-menu">
                <li class="nav-item">
              <div v-if="(users === true && super_user == 1) || shop_user == 2">
                <a href="#/Definesecurity/User" class="nav-link">Add / Update Users</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="super_user == 1">
                <a href="#/Definesecurity/Role" class="nav-link">Add / Update Roles</a>
              </div>
            </li>
              </ul>
            </li>
               <li v-if="sales_tab === true || is_admin === true" class="">
              <div class="nav-link "><i class="fa fa-pie-chart"></i>Sales<i class="fa fa-angle-double-right" style="float: right; color: #fff;"></i>
          </div>
              <ul class="second-level-menu">
                <li v-if="sales === true" class="nav-item">
              <a href="#/sales" class="nav-link">Sale Entry</a>
            </li>
            <!---<li class="nav-item" v-if="sale_return === true">
              <div>
                <a href="#/Salesreturn/list" class="nav-link">Sale Return</a>
              </div>
            </li>----->
            <li v-if="customer === true" class="nav-item">
              <a href="#/sales/Customeradd" class="nav-link">Add / Update Customer</a>
            </li>
            <li v-if="sale_invoice === true" class="nav-item">
              <a href="#/sales/saleinvoice/list" class="nav-link">Sale Invoice</a>
            </li>
            <li v-if="sale_receipt === true" class="nav-item">
              <div>
                <a href="#/sales/salereceipt" class="nav-link">Sales Receipt</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="sale_receipt_history === true">
                <a href="#/sales/Salesreceipthistory" class="nav-link">Sales Receipt History</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="salereturn_receipt_history === true">
                <!-- <div v-if="sale_receipt_history === true"> -->
                  <a href="#/sales/SalesReturnreceipthistory" class="nav-link">Sales Return Receipt History</a>
                </div>
              </li>
              </ul>
            </li>
            <!------purchase---->
               <li v-if="purchase_tab === true">
              <div class=" nav-link">
              <i class="fa fa-shopping-cart"></i>Purchase<i class="fa fa-angle-double-right" style="float: right; color: #fff;"></i>
            </div>
              <ul class="second-level-menu">
                <li v-if="purchase === true" class="nav-item">
                <a href="#/purchase/purchaseentry" class="nav-link">Purchase Entry</a>
              </li>
              <!---<li v-if="purchase_return === true" class="nav-item">
                <a href="#/purchase/Listpurchesreturn" class="nav-link">Purchase Return</a>
              </li>---->
              <li class="nav-item">
                <div v-if="supplier === true">
                  <a href="#/purchase/supplier/add" class="nav-link">Add / Update Supplier</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="purchase_payment === true">
                <a href="#/purchase/addpayment" class="nav-link">Add Payment</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="purchase_payment_history === true">
                <a href="#/purchase/listpayment" class="nav-link">List Payment</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="purchasereturn_pending_list === true">
                <a href="#/purchase/PurchaseReturnpayment" class="nav-link">List Purchase Return Payment</a>
              </div>
            </li>
              </ul>
            </li>
            <li  v-if="shop_inventory === true">
             <div>
                 <a href="#/shopinventory" class="nav-link"><i class="icon-social-dropbox"></i> Shop Inventory</a>
              </div>
          
            </li>
            <li v-if="stock_transfer === true" class="nav-item">
          <div>
            <a href="#/stocktransfer" class="nav-link"><i class="icon-speedometer"></i> Stock Transfer</a>
          </div>
        </li>
         <li v-if="sales_tab === true || purchase_tab === true" class="">
          <div class=" nav-link">
            <i class="fa fa-cogs"></i> Reports<i class="fa fa-angle-double-right" style="float: right; color: #fff;"></i>
          </div>
          <ul class="second-level-menu">
            <li v-if="sales_tab === true" class="nav-item">
              <a href="#/reports/balance_receipt_list" class="nav-link">Balance Receipt List</a>
            </li>
            <li v-if="purchase_tab === true" class="nav-item">
              <a href="#/reports/pending_payment_list" class="nav-link">Pending Payment List</a>
            </li>
          </ul>
        </li>
          <li v-if="setup_tab === true || is_admin === true" class="">
          <div class=" nav-link">
            <i class="fa fa-cogs"></i> Setup<i class="fa fa-angle-double-right" style="float: right; color: #fff;"></i>
          </div>
          <ul class="second-level-menu">
            <li class="nav-item">
              <div v-if="category_sub_category === true || is_admin === true">
                <a href="#/setup/addupdatecategory" class="">Add / Update Category</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="brand === true || is_admin === true">
                <a href="#/setup/addupdatebrand" class="">Add / Update Brand</a>
              </div>
            </li>
            <li v-if="tax_tab === true || is_admin === true" class="">
              <a href="#">Tax Details<i class="fa fa-angle-double-right" style="float: right; color: #fff;"></i></a>
              <ul class="second-level-menu">
                <li v-if="hsn === true || is_admin === true" class="nav-item">
                  <a href="#/setup/taxdetails/hsn" class="nav-link">HSN</a>
                </li>
                <li v-if="tax === true || is_admin === true" class="nav-item">
                  <a href="#/setup/taxdetails/hsnrate" class="nav-link">HSN Rate</a>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <div v-if="variant === true || is_admin === true">
                <a href="#/setup/addupdatevariant">Add / Update Variant</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="unit === true || is_admin === true">
                <a href="#/setup/addupdateunit">Add / Update Unit</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="product === true">
                <a href="#/setup/addupdateproduct" class="">Add / Update Product</a>
              </div>
            </li>
            <li class="nav-item">
              <div v-if="product === true">
                <a href="#/setup/barcode" class="">Print Barcode</a>
              </div>
            </li>
            </ul>
            </li>
        
          </ul>
          
        </li>
        
     
     
         <!-- <li class="nav-item">
            <div>
              <a href="#/createcard" class="nav-link"
              ><i class="icon-social-dropbox"></i> Create Card</a
              >
            </div>
        </li> -->
        <!-- <li class="nav-item">
            <div>
              <a href="#/cardlist" class="nav-link"
              ><i class="icon-social-dropbox"></i> Card List</a
              >
            </div>
        </li> -->
        <!-- <li class="nav-item">
            <div>
              <a href="#/sendsms" class="nav-link"
              ><i class="icon-social-dropbox"></i> Send SMS</a
              >
            </div>
        </li> -->
       
        <!-- <li class="nav-item">
            <div>
              <a href="#/goldscheme" class="nav-link"
              ><i class="icon-social-dropbox"></i>Gold Schemes</a
              >
            </div>
        </li> -->
        <li v-if="setup_tab === true || is_admin === true" class="test2">
          <div class="dropbtn nav-link">
            <i class="fa fa-cogs"></i> Scheme<i class="fa fa-angle-double-right" style="float: right; color: #fff;"></i>
          </div>
          <ul class="test top-level-menu">
            <li class="nav-item">
                <div>
                  <a href="#/sales/Customeradd" class="nav-link">Customer List</a>
                </div>
              </li>
              <li class="nav-item">
            <div>
              <a href="#/createcard" class="nav-link">Create Card</a>
            </div>
            </li>
            <li class="nav-item">
            <div>
              <a href="#/cardlist" class="nav-link"> Card List</a>
            </div>
        </li>
         <li class="nav-item">
            <div>
              <a href="#/closelist" class="nav-link">Card Close List</a>
            </div>
        </li>
        <li class="nav-item">
            <div>
              <a href="#/refwalletlist" class="nav-link">Ref. Wallet List</a>
            </div>
        </li>
         <li class="nav-item">
            <div>
              <a href="#/custDueList" class="nav-link">Customer Due List</a>
            </div>
        </li>
          <li class="nav-item">
            <div>
              <a href="#/schedulesms" class="nav-link"> SMS Scheduler</a>
            </div>
        </li>
         <li class="nav-item">
            <div>
              <a href="#/sendsms" class="nav-link"> Send SMS</a>
            </div>
        </li>
           <!------<li class="nav-item">
            <div>
              <a href="#/cashfreepayment" class="nav-link"> Cash free payment</a>
            </div>
        </li>----->
         <li class="nav-item">
            <div>
              <a href="#/dailyreport" class="nav-link"> Report</a>
            </div>
        </li>
         <li class="nav-item">
            <div>
              <a href="#/goldscheme" class="nav-link">Gold Schemes</a>
            </div>
        </li>

          </ul>
        </li>


        <li v-if="customer_tab === true" class="test2">
          <div>
            <a href="#/customerdashboard" class="nav-link "><i class="icon-speedometer "></i>Dashboard</a>
          </div>
           <div>
            <a href="#/customerdetails" class="nav-link"><i class="icon-speedometer"></i> Profile Detail</a>
          </div>
          <div>
            <a href="#/customerCompany" class="nav-link"><i class="icon-speedometer"></i>Company Schemes</a>
          </div>
          <!-- <div>
            <a href="#/customerPaymentStatement" class="nav-link"><i class="icon-speedometer"></i>Online Payment</a>
          </div> -->
        </li>
      </ul>
      <slot></slot>
    </nav>
    <SidebarFooter />
    <SidebarMinimizer />
  </div>
</div>
</template>

<script>
  import { mapMutations } from "vuex";
  import SidebarFooter from "./SidebarFooter";
  import SidebarForm from "./SidebarForm";
  import SidebarHeader from "./SidebarHeader";
  import SidebarMinimizer from "./SidebarMinimizer";
  import SidebarNavDivider from "./SidebarNavDivider";
  import SidebarNavLink from "./SidebarNavLink";
  import SidebarNavTitle from "./SidebarNavTitle";
  import SidebarNavItem from "./SidebarNavItem";
  import SidebarNavLabel from "./SidebarNavLabel";
  export default {
    name: "sidebar",
    components: {
      SidebarFooter,
      SidebarForm,
      SidebarHeader,
      SidebarMinimizer,
      SidebarNavDivider,
      SidebarNavLink,
      SidebarNavTitle,
      SidebarNavItem,
      SidebarNavLabel,
    },
    data() {
      return {
        roles_data: [],
        dashboard: false,
        company_reg: false,
        shop_details: false,
        users: false,
        roles: false,
        sales: false,
        sale_return: false,
        customer: false,
        sale_invoice: false,
        sale_receipt: false,
        sale_receipt_history: false,
        salereturn_receipt_history : false,
        purchase: false,
        purchase_return: false,
        supplier: false,
        purchase_payment: false,
        purchase_payment_history: false,
        purchasereturn_pending_list : false,
        shop_inventory: false,
        stock_transfer: false,
        product: false,
        category_sub_category: false,
        brand: false,
        tax: false,
        hsn: false,
        cust_pp: true,
        supp_pp: true,
        variant: false,
        unit: false,
        is_admin: false,
        company_tab: false,
        security_tab: false,
        sales_tab: false,
        purchase_tab: false,
        setup_tab: false,
        customer_tab:false,
        tax_tab: false,
        reports_tab: false,
        inventory: false,
        super_user: 3,
        shop_user: 3,
      };
    },
    created() {
    // console.log(this.$store.getters.get_is_admin)
    // if(this.$store.getters.get_is_admin === true){
    //    this.$store.commit('set_cat_view', true)
    //             this.$store.commit('set_cat_rights', true)
    //             this.$store.commit('set_brand_view', true)
    //             this.$store.commit('set_brand_rights', true)
    //             this.$store.commit('set_tax_view', true)
    //             this.$store.commit('set_tax_rights', true)
    //             this.$store.commit('set_hsn_view', true)
    //             this.$store.commit('set_hsn_rights', true)
    //             this.$store.commit('set_var_view', true)
    //             this.$store.commit('set_var_rights', true)
    //             this.$store.commit('set_unit_view', true)
    //             this.$store.commit('set_unit_rights', true)
    // }
    for (var j = 0; j < 29; j++) {
      this.roles_data.push({ page_name: j + 1, view: false, rights: false });
    }
    if (window.localStorage) {
      var localUserString = localStorage.getItem('authUser')
      var localUseremailstatus = localStorage.getItem('authUseremail')
      var localUserstatus = localStorage.getItem('authUserstatus')
     if(localUserString != null){
        if(localUseremailstatus != null){
          if(localUserstatus != null){
            this.getRoles();
          }
        } else {
          this.getCustomerDetails();
        }
      }
    }
 
    
  },
  methods: {
    mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      },
    getRoles() {
      console.log('Inside Customer GetRoles')
      this.loading = true;
      var _this = this;
      var roles = null;
      this.loading = true;
      this.$http
      .get("/api/userroles/userroles")
      .then(function (response) {
          // console.log(response)
          _this.$http
          .get("/api/userroles/usertype")
          .then(function (response1) {
            _this.$http
            .get("/api/userroles/shopusertype")
            .then(function (response2) {
              _this.$store.commit("set_super_user", response1.data);
              _this.super_user = _this.$store.getters.get_super_user;
              _this.$store.commit("set_shop_user", response2.data);
              _this.shop_user = _this.$store.getters.get_shop_user;
              if (!response.data.data) {
                roles = null;
              } else {
                roles = response.data.data;
                for (var i = 0; i < roles.length; i++) {
                  for (var k = 0; k < roles[i].length; k++) {
                    if (
                      roles[i][k].page_name == _this.roles_data[k].page_name
                      ) {
                          // VIEW
                        if (
                          _this.roles_data[k].view == true &&
                          roles[i][k].view == true
                          ) {
                          _this.roles_data[k].view = true;
                      } else if (
                        _this.roles_data[k].view == false &&
                        roles[i][k].view == false
                        ) {
                        _this.roles_data[k].view = false;
                      } else {
                        _this.roles_data[k].view = true;
                      }
                          // RIGHTS
                          if (
                            _this.roles_data[k].rights == true &&
                            roles[i][k].rights == true
                            ) {
                            _this.roles_data[k].rights = true;
                        } else if (
                          _this.roles_data[k].rights == false &&
                          roles[i][k].rights == false
                          ) {
                          _this.roles_data[k].rights = false;
                        } else {
                          _this.roles_data[k].rights = true;
                        }
                      }
                    }
                  }
                  if (_this.roles_data[0].page_name === 1) {
                    _this.$store.commit(
                      "set_dashbd_view",
                      _this.roles_data[0].view
                      );
                    _this.$store.commit(
                      "set_dashbd_rights",
                      _this.roles_data[0].rights
                      );
                  }

                  if (_this.roles_data[1].page_name === 2) {
                    _this.$store.commit(
                      "set_reg_view",
                      _this.roles_data[1].view
                      );
                    _this.$store.commit(
                      "set_reg_rights",
                      _this.roles_data[1].rights
                      );
                  }

                  if (_this.roles_data[2].page_name === 3) {
                    _this.$store.commit(
                      "set_shop_view",
                      _this.roles_data[2].view
                      );
                    _this.$store.commit(
                      "set_shop_rights",
                      _this.roles_data[2].rights
                      );
                  }

                  if (_this.roles_data[3].page_name === 4) {
                    _this.$store.commit(
                      "set_u_view",
                      _this.roles_data[3].view
                      );
                    _this.$store.commit(
                      "set_u_rights",
                      _this.roles_data[3].rights
                      );
                  }
                  if (_this.roles_data[4].page_name === 5) {
                    _this.$store.commit(
                      "set_r_view",
                      _this.roles_data[4].view
                      );
                    _this.$store.commit(
                      "set_r_rights",
                      _this.roles_data[4].rights
                      );
                  }
                  if (_this.roles_data[7].page_name === 8) {
                    _this.$store.commit(
                      "set_cust_view",
                      _this.roles_data[7].view
                      );
                    _this.$store.commit(
                      "set_cust_rights",
                      _this.roles_data[7].rights
                      );
                  }
                  if (_this.roles_data[13].page_name === 14) {
                    _this.$store.commit(
                      "set_sup_view",
                      _this.roles_data[13].view
                      );
                    _this.$store.commit(
                      "set_sup_rights",
                      _this.roles_data[13].rights
                      );
                  }
                  if (_this.roles_data[16].page_name === 17) {
                    _this.$store.commit(
                      "set_invt_view",
                      _this.roles_data[16].view
                      );
                    _this.$store.commit(
                      "set_invt_rights",
                      _this.roles_data[16].rights
                      );
                  }
                  if (_this.roles_data[17].page_name === 18) {
                    _this.$store.commit(
                      "set_stcktran_view",
                      _this.roles_data[17].view
                      );
                    _this.$store.commit(
                      "set_stcktran_rights",
                      _this.roles_data[17].rights
                      );
                  }
                  if (_this.roles_data[18].page_name === 19) {
                    _this.$store.commit(
                      "set_prod_view",
                      _this.roles_data[18].view
                      );
                    _this.$store.commit(
                      "set_prod_rights",
                      _this.roles_data[18].rights
                      );
                  }
                  if (_this.roles_data[19].page_name === 20) {
                    _this.$store.commit(
                      "set_cat_view",
                      _this.roles_data[19].view
                      );
                    _this.$store.commit(
                      "set_cat_rights",
                      _this.roles_data[19].rights
                      );
                  }
                  if (_this.roles_data[20].page_name === 21) {
                    _this.$store.commit(
                      "set_brand_view",
                      _this.roles_data[20].view
                      );
                    _this.$store.commit(
                      "set_brand_rights",
                      _this.roles_data[20].rights
                      );
                  }
                  if (_this.roles_data[21].page_name === 22) {
                    _this.$store.commit(
                      "set_tax_view",
                      _this.roles_data[21].view
                      );
                    _this.$store.commit(
                      "set_tax_rights",
                      _this.roles_data[21].rights
                      );
                  }

                  if (_this.roles_data[22].page_name === 23) {
                    _this.$store.commit(
                      "set_hsn_view",
                      _this.roles_data[22].view
                      );
                    _this.$store.commit(
                      "set_hsn_rights",
                      _this.roles_data[22].rights
                      );
                  }
                  if (_this.roles_data[23].page_name === 24) {
                    _this.$store.commit(
                      "set_var_view",
                      _this.roles_data[23].view
                      );
                    _this.$store.commit(
                      "set_var_rights",
                      _this.roles_data[23].rights
                      );
                  }
                  if (_this.roles_data[24].page_name === 25) {
                    _this.$store.commit(
                      "set_unit_view",
                      _this.roles_data[24].view
                      );
                    _this.$store.commit(
                      "set_unit_rights",
                      _this.roles_data[24].rights
                      );
                  }
                    // if(_this.roles_data[25].page_name === 26){
                    //   console.log(_this.roles_data[25])
                    // }
                    if (_this.roles_data[11].page_name === 12) {
                      _this.$store.commit(
                        "set_pur_view",
                        _this.roles_data[11].view
                        );
                      _this.$store.commit(
                        "set_pur_rights",
                        _this.roles_data[11].rights
                        );
                    }
                    if (_this.roles_data[12].page_name === 13) {
                      _this.$store.commit(
                        "set_purrt_view",
                        _this.roles_data[12].view
                        );
                      _this.$store.commit(
                        "set_purrt_rights",
                        _this.roles_data[12].rights
                        );
                    }
                    if (_this.roles_data[5].page_name === 6) {
                      _this.$store.commit(
                        "set_sale_view",
                        _this.roles_data[5].view
                        );
                      _this.$store.commit(
                        "set_sale_rights",
                        _this.roles_data[5].rights
                        );
                    }
                    if (_this.roles_data[6].page_name === 7) {
                      _this.$store.commit(
                        "set_salert_view",
                        _this.roles_data[6].view
                        );
                      _this.$store.commit(
                        "set_salert_rights",
                        _this.roles_data[6].rights
                        );
                    }
                    if (_this.roles_data[10].page_name === 11) {
                      _this.$store.commit(
                        "set_salerechis_view",
                        _this.roles_data[10].view
                        );
                      _this.$store.commit(
                        "set_salerechis_rights",
                        _this.roles_data[10].rights
                        );
                    }
                    if (_this.roles_data[9].page_name === 10) {
                      _this.$store.commit(
                        "set_salerec_view",
                        _this.roles_data[9].view
                        );
                      _this.$store.commit(
                        "set_salerec_rights",
                        _this.roles_data[9].rights
                        );
                    }
                    if (_this.roles_data[8].page_name === 9) {
                      _this.$store.commit(
                        "set_saleinvoice_view",
                        _this.roles_data[8].view
                        );
                      _this.$store.commit(
                        "set_saleinvoice_rights",
                        _this.roles_data[8].rights
                        );
                    }
                    if (_this.roles_data[14].page_name === 15) {
                      _this.$store.commit(
                        "set_purpay_view",
                        _this.roles_data[14].view
                        );
                      _this.$store.commit(
                        "set_purpay_rights",
                        _this.roles_data[14].rights
                        );
                    }
                    if (_this.roles_data[15].page_name === 16) {
                      _this.$store.commit(
                        "set_purpayhis_view",
                        _this.roles_data[15].view
                        );
                      _this.$store.commit(
                        "set_purpayhis_rights",
                        _this.roles_data[15].rights
                        );
                    }
                    if (_this.roles_data[25].page_name === 26) {
                      _this.$store.commit(
                        "set_salereturnpay_view",
                        _this.roles_data[25].view
                        );
                      _this.$store.commit(
                        "set_salereturnpay_rights",
                        _this.roles_data[25].rights
                        );
                    }
                    if (_this.roles_data[26].page_name === 27) {
                      _this.$store.commit(
                        "set_purchasereturnpay_view",
                        _this.roles_data[26].view
                        );
                      _this.$store.commit(
                        "set_puchasereturnpay_rights",
                        _this.roles_data[26].rights
                        );
                    }
                    _this.check();
                    _this.loading = false;
                  }
                })
.catch(function (error) {
 console.log(error)
 _this.loading = false;
 _this.$store.commit("set_shop_user", "3");
});
})
.catch(function (error) {
  _this.loading = false;
  _this.$store.commit("set_super_user", "3");
});
})
.catch(function (error) {
  console.log(error)
  _this.loading = false;
});
},

getCustomerDetails(){
console.log('Inside customer Details')
this.customer_tab = true
},

handleClick(e) {
  e.preventDefault();
  e.target.parentElement.classList.toggle("open");
},
handleClick1(e) {
  e.preventDefault();
  e.target.parentElement.classList.toggle("open");
},

check() {
  var roles = this.roles_data;
      // var roles = JSON.parse(this.$store.state.roles)
      // var roles = this.$store.state.userStore.roles
      if (roles != null) {
        if (roles.length > 0) {
          for (var i = 0; i < roles.length; i++) {
            if (roles[i].page_name == 1) {
              // this.dashboard = true // roles[i].view
              this.dashboard = roles[i].view;
            } else if (roles[i].page_name == 2) {
              this.company_reg = roles[i].view;
            } else if (roles[i].page_name == 3) {
              this.shop_details = roles[i].view;
            } else if (roles[i].page_name == 4) {
              this.users = roles[i].view;
            } else if (roles[i].page_name == 5) {
              this.roles = roles[i].view;
            } else if (roles[i].page_name == 6) {
              this.sales = roles[i].view;
            } else if (roles[i].page_name == 7) {
              this.sale_return = roles[i].view;
            } else if (roles[i].page_name == 8) {
              this.customer = roles[i].view;
            } else if (roles[i].page_name == 9) {
              this.sale_invoice = roles[i].view;
            } else if (roles[i].page_name == 10) {
              this.sale_receipt = roles[i].rights;
            } else if (roles[i].page_name == 11) {
              this.sale_receipt_history = roles[i].view;
            } else if (roles[i].page_name == 12) {
              this.purchase = roles[i].view;
            } else if (roles[i].page_name == 13) {
              this.purchase_return = roles[i].view;
            } else if (roles[i].page_name == 14) {
              this.supplier = roles[i].view;
            } else if (roles[i].page_name == 15) {
              this.purchase_payment = roles[i].rights;
            } else if (roles[i].page_name == 16) {
              this.purchase_payment_history = roles[i].view;
            } else if (roles[i].page_name == 17) {
              this.shop_inventory = roles[i].view;
            } else if (roles[i].page_name == 18) {
              this.stock_transfer = roles[i].view;
            } else if (roles[i].page_name == 19) {
              this.product = roles[i].view;
            } else if (roles[i].page_name == 20) {
              this.category_sub_category = roles[i].view;
            } else if (roles[i].page_name == 21) {
              this.brand = roles[i].view;
            } else if (roles[i].page_name == 22) {
              this.tax = roles[i].view;
            } else if (roles[i].page_name == 23) {
              this.hsn = roles[i].view;
            } else if (roles[i].page_name == 24) {
              this.variant = roles[i].view;
            } else if (roles[i].page_name == 25) {
              this.unit = roles[i].view;
            } else if (roles[i].page_name == 26) {
              this.salereturn_receipt_history = roles[i].view; 
            }else if (roles[i].page_name == 27) {
              this.purchasereturn_pending_list = roles[i].view;
            }else if (roles[i].page_name == 28) {
             this.is_admin = roles[i].view;
           }else if (roles[i].page_name == 29) {
            this.is_admin = roles[i].view;
          }
        }

        if (this.super_user == 1 || this.shop_user == 2) {
          if (this.company_reg == false && this.shop_details == false) {
            this.company_tab = false;
          } else {
            this.company_tab = true;
          }
        } else {
          this.company_tab = false;
        }

        if (this.super_user == 1 || this.shop_user == 2) {
          if (this.users == false && this.roles == false) {
            this.security_tab = false;
          } else {
            this.security_tab = true;
          }
        } else {
          this.security_tab = false;
        }

        if (
          this.sales == false &&
          this.sale_return == false &&
          this.customer == false &&
          this.sale_invoice == false &&
          this.sale_receipt == false &&
          this.sale_receipt_history == false&&
          this.salereturn_receipt_history == false
          ) {
          this.sales_tab = false;
      } else {
        this.sales_tab = true;
      }

      if (
        this.purchase == false &&
        this.purchase_return == false &&
        this.supplier == false &&
        this.purchase_payment == false &&
        this.purchase_payment_history == false &&
        this.purchasereturn_pending_list == false
        ) {
        this.purchase_tab = false;
            // console.log(this.purchase_tab)
            // console.log('false')
          } else {
            this.purchase_tab = true;
          }

          if (
            this.product == false &&
            this.category_sub_category == false &&
            this.brand == false &&
            this.tax == false &&
            this.hsn == false &&
            this.variant == false &&
            this.unit == false
            ) {
            this.setup_tab = false;
        } else {
          this.setup_tab = true;
        }

        if (this.tax == false && this.hsn == false) {
          this.tax_tab = false;
        } else {
          this.tax_tab = true;
        }
      }
    }
  },
},
};
</script>

<style lang="css">
  .nav-link {
    cursor: pointer;
  }
  @media screen and (max-width: 1024px) {
    #destop {
      display: none;
    }
  }
  @media screen and (min-width: 1025px) {
    #mobile {
      display: none;
    }
  }
  .test2 {
    position: relative !important;
    display: inline-block !important;
  }
  ul.test {
    list-style-type: none !important;
    margin-left: 196px !important;
    margin-top: -38px !important;
    padding: 0 !important;
    color: #fff !important;
  }
  .test {
    list-style-type: none !important;
    color: #fff !important;
    display: none !important;
    position: fixed !important;
    background-color: #212b31 !important;
    min-width: 190px !important;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2) !important;
    z-index: 1 !important;
    margin-left: 196px !important;
    margin-top: -45px !important;
  }
  .test a {
    color: #fff !important;
    padding: 8px 8px !important;
    text-decoration: none !important;
    display: block !important;
  }
  .test a:hover {
    background-color: #20a8d8 !important;
    color: #000 !important;
  }
  .test2:hover .test {
    display: block !important;
  }
  .test2:hover .dropbtn {
    background-color: #20a8d8 !important;
  }
  .second-level-menu {
    list-style-type: none !important;
    background-color: #29363d !important;
    min-width: 190px !important;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2) !important;
    z-index: 1 !important;
    margin-left: 184px !important;
    margin-top: -37px !important;
    position: absolute !important;
    list-style: none !important;
    display: none !important;
    width: 160px !important;
  }
  .second-level-menu > li {
    position: relative !important;
    margin-left: 1px !important;
  }
  .second-level-menu > li:hover {
    background: red;
  }
  .top-level-menu {
  }
  .top-level-menu > li {
    position: relative !important;
  }
  .top-level-menu li:hover {
    background: #20a8d8;
  }
  .top-level-menu li:hover > ul {
    display: block !important;
    padding-left: 0px !important;
  }
  .top-level-menu a {
    display: block;
  }
  .top-level-menu a:hover {
    color: #000000;
  }
  .sidebar .nav-dropdown-toggle::before {
    background-image: none !important;
  }
  .sidebar .nav-link,
  .sidebar .navbar .dropdown-toggle,
  .navbar .sidebar .dropdown-toggle {
    padding: 0.5rem 1rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/Sidebar.vue